import { useContext } from 'react'

import { AccordionContext } from './accordion-context'

export const useAccordion = () => useContext(AccordionContext)
